import React from 'react'
// import { ValueSelector } from 'react-querybuilder'
import { InputFieldColumnSimple } from '../InputField'
import { BaseSelect } from '../../../../select/ReportSelect'
import { capitalizeWords } from '../../../../../../utils/reporting/config'

const formatOptionLabel = (option) => {
    const capitalizedLabel = capitalizeWords(option.label)

    if (capitalizedLabel && capitalizedLabel.includes('.')) {
        const parts = capitalizedLabel.split('.')
        if (parts.length >= 2) {
            const tableName = parts[0]
            const columnName = parts.slice(1).join('.')

            return (
                <span>
                    {tableName}.<strong>{columnName}</strong>
                </span>
            )
        }
    }

    return <span>{capitalizedLabel}</span>
}

const CustomValueSelector = (props) => {
    const disabled = props.context && props.context.viewOnly ? true : false
    const options = props.options.map((v) => ({ value: v.name, ...v }))
    const defaultVal = options.find((x) => x.value === props.value) || ''

    //get the character lenght of the biggest option to dinamically set the length of the component
    const biggestOptionCharacterLength = Math.max(
        ...options.map((x) => x.label.length + 1)
    )
    const key =
        props &&
        props.rule &&
        `${props.rule.id}.${props.title}.${props.rule.value}`
    return (
        <div
            style={{
                ...props.style,
                minWidth:
                    (props.style && props.style.width) ||
                    `calc(${biggestOptionCharacterLength}ch + 25px)`,
            }}
            title={defaultVal.value}
        >
            <BaseSelect
                key={key}
                isClearable={false}
                options={options}
                isDisabled={disabled}
                // defaultValue={defaultVal}
                value={defaultVal}
                className={props.className}
                formatOptionLabel={formatOptionLabel}
                onChange={(selectedValue) => {
                    props.handleOnChange(selectedValue.value)
                    return selectedValue
                }}
            />
        </div>
    )
}

const CustomCombinatorSelector = (props) => {
    const isJoin = props.context?.sourceType === 'join'

    const options = isJoin
        ? props.options.filter((opt) => opt.value === 'and')
        : props.options

    return (
        <CustomValueSelector
            style={{
                maxWidth: '80px',
                marginLeft: '16px',
            }}
            {...props}
            context={{
                ...props.context,
                viewOnly: isJoin || props.context?.viewOnly, // força readonly se for join
            }}
            options={options}
            value={isJoin ? 'and' : props.value}
        />
    )
}

const CustomOperatorSelector = (props) => {
    const fieldData = props && props.fieldData
    const disabled = props.context && props.context.viewOnly ? true : false

    return (
        <>
            <InputFieldColumnSimple
                name={props.rule.id}
                viewOnly={true}
                inputProps={{
                    ...{
                        style: { marginBottom: 0 },
                        type: 'text',
                        value: fieldData.dataTypeDisplay,
                        title: fieldData.dataTypeDisplay,
                    },
                }}
            />
            <CustomValueSelector
                key={`${props.rule.id}${props.value}`}
                {...props}
                disabled={disabled}
            />
        </>
    )
}

const CustomDragIcon = React.forwardRef(({ className }, ref) => (
    <span
        className={`drag-icon-wrapper ${className}`}
        title=""
        ref={ref}
        style={{ fontSize: '12px', padding: '0 4px', cursor: 'grab' }}
    >
        <i className="fas fa-grip-vertical"></i>
    </span>
))

export default CustomValueSelector
export { CustomOperatorSelector, CustomCombinatorSelector, CustomDragIcon }
